interface ContactCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: 'blue' | 'green' | 'purple' | 'yellow';
  action?: {
    label: string;
    href: string;
  };
}

const colorClasses = {
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-600',
    hover: 'hover:bg-blue-600',
    border: 'border-blue-200',
  },
  green: {
    bg: 'bg-green-100',
    text: 'text-green-600',
    hover: 'hover:bg-green-600',
    border: 'border-green-200',
  },
  purple: {
    bg: 'bg-purple-100',
    text: 'text-purple-600',
    hover: 'hover:bg-purple-600',
    border: 'border-purple-200',
  },
  yellow: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-600',
    hover: 'hover:bg-yellow-600',
    border: 'border-yellow-200',
  },
};

export default function ContactCard({ icon, title, description, color, action }: ContactCardProps) {
  const colors = colorClasses[color];

  return (
    <div data-component-id="src/components/contact/ContactCard.tsx:43:4" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="43" data-component-file="ContactCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`group bg-white p-4 sm:p-6 rounded-xl border ${colors.border} shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1`}>
      <div data-component-id="src/components/contact/ContactCard.tsx:44:6" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="44" data-component-file="ContactCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20space-x-4%22%7D" className="flex items-start space-x-4">
        <div data-component-id="src/components/contact/ContactCard.tsx:45:8" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="45" data-component-file="ContactCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${colors.bg} p-3 rounded-lg group-hover:scale-110 transition-transform`}>
          <div data-component-id="src/components/contact/ContactCard.tsx:46:10" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="46" data-component-file="ContactCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={colors.text}>{icon}</div>
        </div>
        <div data-component-id="src/components/contact/ContactCard.tsx:48:8" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="48" data-component-file="ContactCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
          <h3 data-component-id="src/components/contact/ContactCard.tsx:49:10" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="49" data-component-file="ContactCard.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-bold%20text-gray-900%20mb-2%22%7D" className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
          <p data-component-id="src/components/contact/ContactCard.tsx:50:10" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="50" data-component-file="ContactCard.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-gray-600%20leading-relaxed%22%7D" className="text-gray-600 leading-relaxed">{description}</p>
          {action && (
            <a data-component-id="src/components/contact/ContactCard.tsx:52:12" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="52" data-component-file="ContactCard.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
              href={action.href}
              className={`inline-flex items-center mt-4 text-sm font-semibold ${colors.text} hover:underline`}
            >
              {action.label}
              <svg data-component-id="src/components/contact/ContactCard.tsx:57:14" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="57" data-component-file="ContactCard.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-4%20h-4%20ml-1%22%7D" className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path data-component-id="src/components/contact/ContactCard.tsx:58:16" data-component-path="src/components/contact/ContactCard.tsx" data-component-line="58" data-component-file="ContactCard.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}